import classnames from "classnames";
import { DetailedHTMLProps, HTMLAttributes } from "react";

export type PageProps = {
  children: React.ReactNode;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export function Page(props: PageProps) {
  const { children, className } = props;

  const rootStyle = classnames("flex flex-col flex-grow gap-8 container", {
    [`${className}`]: Boolean(className),
  });

  return <div className={rootStyle}>{children}</div>;
}
